import http from '../http';

const API_BASE_URL = '/api/v1/dilutionsolventratio';

/**
 * 희석 용매비 목록 조회
 * @param {Object} params - 검색 조건 (additive, currentPage, pageSize)
 * @returns {Promise} API 응답
 */
export const getDilutionSolventRatioList = params => {
  return http.post(`${API_BASE_URL}/list`, params);
};

/**
 * 첨가제 드롭다운 목록 조회 (중복 제거)
 */
export const getAdditives = () => {
  return http.get(`${API_BASE_URL}/additives`);
};

/**
 * 희석 용매비 등록
 * @param {Object} data - 등록할 데이터
 * @returns {Promise} API 응답
 */
export const insertDilutionSolventRatio = data => {
  return http.post(`${API_BASE_URL}/insert`, data);
};

/**
 * 희석 용매비 삭제
 * @param {number} id - 삭제할 희석 용매비 ID
 * @returns {Promise} API 응답
 */
export const deleteDilutionSolventRatio = id => {
  return http.delete(`${API_BASE_URL}/delete/${id}`);
};

/**
 * 사내통용 원료명칭 검색 (첨가제, 희석원료용)
 * @param {Object} params - 검색 조건 (searchKeyword, currentPage, pageSize)
 * @returns {Promise} API 응답
 */
export const searchInternalMaterials = params => {
  return http.post(`${API_BASE_URL}/search/internalmaterials`, params);
};

/**
 * 우선순위 일괄 업데이트
 * @param {Array<{id:number, priority:number}>} items - 업데이트할 항목 배열
 * @returns {Promise} API 응답
 */
export const updatePriorities = items => {
  return http.post(`${API_BASE_URL}/priority/update`, items);
};
